<script>
import { vendorService } from "../../services";
import {
  error_message,
  success_message,
} from "../../Helper/helper";

export default {
  components: { vendorService },
  props: ["rest_data"],
  data() {
    return {
      restaurant: {
        user_id: this.rest_data.user_id,
      },
      isLoading: false,
      error: [],
      typeform: {
        restaurant_id: this.$route.params.restaurant_id,
        customer_type: 2,
      },
      parking: {
        business: [{ parking: "" }],
        private: [{ parking: "" }],
      },
      showForm: false,
    };
  },
  mounted() {
    this.getRestaurantById();
  },
  methods: {
    getUser() {
      this.users = this.$auth.user;
      this.userdetail = this.$auth.setting;
    },
    AddField(type) {
      if (type === 'business') {
        this.parking.business.push({ parking: "" });
      } else if (type === 'private') {
        this.parking.private.push({ parking: "" });
      }
    },
    removeField(index, type) {
      if (type === 'business') {
        this.parking.business.splice(index, 1);
      } else if (type === 'private') {
        this.parking.private.splice(index, 1);
      }
      this.showForm = this.parking.business.length > 0 || this.parking.private.length > 0;
    },
    getRestaurantById() {
      vendorService
        .getRestaurantById({
          restaurant_id: this.$route.params.restaurant_id,
        })
        .then((response) => {
          const restaurantData = response.data.result;
          if (restaurantData.parking_place) {
            try {
              const parkingData = JSON.parse(restaurantData.parking_place);
              if (Array.isArray(parkingData)) {
                parkingData.forEach((item) => {
                  if (item.customer_type === "1" || item.customer_type === 1) {
                    this.parking.business = item.parking.map(p => ({ parking: p }));
                  } else if (item.customer_type === "2" || item.customer_type === 2) {
                    this.parking.private = item.parking.map(p => ({ parking: p }));
                  }
                });
              } else {
                console.error("Invalid parking data format.");
              }
            } catch (e) {
              console.error("Error parsing parking_place:", e);
            }
          }
        });
    },
    handleCustomerTypeChange() {
      if (this.typeform.customer_type == "1") { // Business
        if (this.parking.business.length == 0) {
          this.parking.business = [{ parking: "" }];
        }
      } else if (this.typeform.customer_type == "2") { // Private
        if (this.parking.private.length == 0) {
          this.parking.private = [{ parking: "" }];
        }
      }
      this.showForm = this.parking.business.length > 0 || this.parking.private.length > 0;
    },
    typeForm() {
      const parkingData = this.typeform.customer_type == "1"
        ? this.parking.business.map(p => p.parking)
        : this.parking.private.map(p => p.parking);

      const formData = {
        restaurant_id: this.typeform.restaurant_id,
        customer_type: this.typeform.customer_type,
        parking: parkingData,
      };
      vendorService.parkingPlace(formData)
        .then((response) => {
          // this.$router.push({ name: "vendor-detail" });
          success_message(response.data.message);
        })
        .catch(error => {
          console.error("Error submitting form:", error);
           error_message(response.data.message);
        });
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="typeForm">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <input
                id="restaurant_id"
                name="restaurant_id"
                type="hidden"
                v-model="typeform.restaurant_id"
                class="form-control"
              />
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="required">{{ trans.trans('__JSON__.Customer Type') }}</label>
                <select class="custom-select" v-model="typeform.customer_type" id="customer_type" name="customer_type" @change="handleCustomerTypeChange">
                  <option value="1">Business</option>
                  <option value="2">Private</option>
                </select>
              </div>
            </div>
            <!-- Show parking fields for Business -->
            <div class="col-sm-6" v-if="typeform.customer_type == 1">
              <div class="row" v-for="(field, index) in parking.business" :key="'business-' + index">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Parking</label>
                    <input
                      v-model="field.parking"
                      type="text"
                      class="form-control"
                      placeholder="Parking"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <button type="button" class="btn btn-primary btn-sm btn-rounded" @click="AddField('business')">+</button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm btn-rounded"
                    v-if="index != 0"
                    @click="removeField(index, 'business')"
                  >
                    -
                  </button>
                </div>
              </div>
            </div>
            <!-- Show parking fields for Private -->
            <div class="col-sm-6" v-if="typeform.customer_type == 2">
              <div class="row" v-for="(field, index) in parking.private" :key="'private-' + index">
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Parking</label>
                    <input
                      v-model="field.parking"
                      type="text"
                      class="form-control"
                      placeholder="Parking"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <button type="button" class="btn btn-primary btn-sm btn-rounded" @click="AddField('private')">+</button>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm btn-rounded"
                    v-if="index != 0"
                    @click="removeField(index, 'private')"
                  >
                    -
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <button type="submit" class="btn btn-primary mr-1 mt-3">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>


<style>
</style>
